import { render, staticRenderFns } from "./OptionProposals.vue?vue&type=template&id=17a16aba&"
import script from "./OptionProposals.vue?vue&type=script&lang=js&"
export * from "./OptionProposals.vue?vue&type=script&lang=js&"
import style0 from "./OptionProposals.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports